import React, { useEffect, useState } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { useAddDispatcherNotesMutation, useLazyGetSelectedOrderDetailsQuery } from '../../../../../features/Dispatch/DispatchSlice';

const DispatcherNotes = ({ setSelectedOrder, selectedOrder, divisionId }) => {
    const [isEdit, setIsEdit] = useState(false);
    const [addDispatcherNotes] = useAddDispatcherNotesMutation();
    const [noteText, setNoteText] = useState("");
    const [triggerGetSelectedOrderDetails] = useLazyGetSelectedOrderDetailsQuery();

    const dispatchNotes = selectedOrder?.dispatcherNotes;
    // useEffect(() => {
    //     if (!dispatchNotes) {
    //         setIsEdit(true);
    //         setNoteText("");
    //     } else {
    //         setIsEdit(false);
    //         setNoteText(dispatchNotes);
    //     }
    // }, [dispatchNotes]);

    const handleNoteChange = (e) => {
        setNoteText(e.target.value);
    };

    const SubmitHandler = async () => {
        const data = {
            orderNo: selectedOrder?.orderNumber,
            dispatcherNotes: noteText,
        }
        const result = await addDispatcherNotes(data);
        if (result?.data?.statusCode === 200) {
            const order = await triggerGetSelectedOrderDetails({
                divisionId: divisionId,
                orderId: selectedOrder.orderId,
            });
            setSelectedOrder(order.data.data);
        }
        setIsEdit(false);
    }

    const mockData = [{
        title: "Received Payment - send it to all accounts",
        sender: "Administrator",
        date: "18/11/2023",
    }, {
        title: "In Progress",
        sender: "Administrator",
        date: "18/11/2023"
    }, {
        title: "Sent",
        sender: "Administrator",
        date: "18/11/2023"
    },
    {
        title: "Received Payment - send it to all accounts",
        sender: "Administrator",
        date: "18/11/2023",
    }, {
        title: "In Progress",
        sender: "Administrator",
        date: "18/11/2023"
    }, {
        title: "Sent",
        sender: "Administrator",
        date: "18/11/2023"
    }]

    return (
        <>
            <Col sm={12}>
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Control
                        placeholder='Type your comment here...'
                        as="textarea"
                        rows={3}
                        value={noteText}
                        onChange={handleNoteChange}
                    // readOnly={!isEdit}
                    />
                </Form.Group>
            </Col >
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px", marginBottom: "10px" }}>
                <div style={{ minWidth: "120px" }}>
                    {/* {isEdit ?
                        (<Button variant="primary" className={"save-btn"} onClick={SubmitHandler}>Save</Button>) : (
                            <Button variant="primary" className={"save-btn"} onClick={() => setIsEdit(!isEdit)}>Edit</Button>
                        )} */}
                    <Button variant="primary" className={"save-btn"}>Add Notes</Button>
                </div>
            </div >
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                {mockData.map((item, index) => {
                    return (
                        <div key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "10px", marginRight: "10px" }}>
                            <div style={{ display: "flex" }}>
                                <li style={{ marginTop: "-8px", fontSize: "20px", color: "rgb(30, 68, 148)" }}></li>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <p>{item.title}</p>
                                    <p className='text-sm text-muted'>{item.sender}</p>
                                </div>
                            </div>
                            <p className='text-sm text-muted'>{item.date}</p>
                        </div>
                    )
                })}
            </div>
        </>
    );
}

export default DispatcherNotes;